export const IS_ENV_DEV = /dev|localhost/.test(window.location.hostname);
